module.exports = __webpack_public_path__ + "img/Refresh.997cabe6.png";